(function () {
  const inr = (n) => '₹' + Number(n).toLocaleString('en-IN');

  // Free-gift variants already added to the cart this page load, so we never
  // re-add the same variant on every re-render (the drawer re-renders a lot).
  const addedVariants = new Set();

  // Reward-product variant ids from the most recently rendered bar, used to
  // tag matching cart rows with a "Free" badge — but only once their actual
  // line price is really ₹0 (i.e. after the merchant's Automatic Discount
  // has kicked in), so the badge never lies about the price being charged.
  let rewardVariantIds = [];

  function tagFreeGifts() {
    if (!rewardVariantIds.length) return;
    document.querySelectorAll('[id^="cart-qty-"]').forEach((input) => {
      const variantId = Number(input.id.replace('cart-qty-', '').split(':')[0]);
      if (!rewardVariantIds.includes(variantId)) return;

      const row = input.closest('tr.cart-item');
      if (!row) return;

      const finalPrice = Number(input.dataset.finalPrice);
      const isFree = finalPrice === 0;

      row.querySelectorAll('.price').forEach((priceEl) => {
        const existing = priceEl.querySelector('.pdb__free-tag');
        if (isFree && !existing) {
          const tag = document.createElement('span');
          tag.className = 'pdb__free-tag';
          tag.textContent = 'Free';
          priceEl.prepend(tag);
        } else if (!isFree && existing) {
          existing.remove();
        }
      });
    });
  }

  async function addRewardToCart(root, variantId) {
    if (!variantId || addedVariants.has(variantId)) return;
    addedVariants.add(variantId);

    const addUrl = root.dataset.addUrl || '/cart/add.js';
    const cartUrl = root.dataset.cartUrl || '/cart.js';

    try {
      const cartRes = await fetch(cartUrl);
      const cart = await cartRes.json();
      const alreadyInCart = cart.items.some((item) => item.variant_id === variantId);
      if (alreadyInCart) return;

      const addRes = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _pdb_free_gift: 'true' } }],
        }),
      });
      if (!addRes.ok) {
        addedVariants.delete(variantId);
        return;
      }

      if (window.Alpine && Alpine.store('xMiniCart')) {
        Alpine.store('xMiniCart').reLoad();
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (addError) {
      addedVariants.delete(variantId);
    }
  }

  async function removeRewardFromCart(root, variantId) {
    if (!addedVariants.has(variantId)) return;
    addedVariants.delete(variantId);

    const cartUrl = root.dataset.cartUrl || '/cart.js';
    const changeUrl = root.dataset.changeUrl || '/cart/change.js';

    try {
      const cartRes = await fetch(cartUrl);
      const cart = await cartRes.json();
      const giftLine = cart.items.find(
        (item) => item.variant_id === variantId && item.properties && item.properties._pdb_free_gift === 'true'
      );
      if (!giftLine) return;

      const removeRes = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 }),
      });
      if (!removeRes.ok) {
        addedVariants.add(variantId);
        return;
      }

      if (window.Alpine && Alpine.store('xMiniCart')) {
        Alpine.store('xMiniCart').reLoad();
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (removeError) {
      addedVariants.add(variantId);
    }
  }

  function render(root) {
    const tiers    = (root.dataset.tiers || '').split(',').map(Number);
    const labels   = (root.dataset.labels || '').split(',');
    const images   = (root.dataset.images || '').split(',');
    const variants = (root.dataset.variants || '').split(',').map((v) => (v ? Number(v) : 0));
    const total    = Number(root.dataset.total || 0);
    const n        = tiers.length;
    if (!n) return;

    const pos = tiers.map((_, i) => ((i + 0.5) / n) * 100);

    root.querySelector('[data-pdb-markers]').innerHTML = tiers.map((amt, i) => `
      <div class="pdb__marker ${total >= amt ? 'is-reached' : ''}" style="left:${pos[i]}%">
        <span class="pdb__marker-amount">${inr(amt)}</span>
        <span class="pdb__marker-icon">${total >= amt ? '🎉' : '🎁'}</span>
        ${images[i]
          ? `<img class="pdb__marker-image" src="${images[i]}" alt="${labels[i] || ''}">`
          : `<span class="pdb__marker-label">${labels[i]}</span>`}
      </div>`).join('');

    let fill;
    if (total >= tiers[n - 1]) {
      fill = 100;
    } else {
      const i = tiers.findIndex((t) => total < t);
      const prevAmt = i === 0 ? 0 : tiers[i - 1];
      const prevPos = i === 0 ? 0 : pos[i - 1];
      fill = prevPos + ((total - prevAmt) / (tiers[i] - prevAmt)) * (pos[i] - prevPos);
    }
    // paint ke baad width set karo taaki transition dikhe
    requestAnimationFrame(() => {
      root.querySelector('[data-pdb-fill]').style.width = fill + '%';
    });

    const next = tiers.findIndex((t) => total < t);
    root.querySelector('[data-pdb-message]').innerHTML = next === -1
      ? `You unlocked <strong>${labels[n - 1]}</strong> — maximum discount!`
      : `Add <strong>${inr(tiers[next] - total)}</strong> more to get <strong>${labels[next]}</strong>`;

    rewardVariantIds = variants.filter((v) => v);

    tiers.forEach((amt, tierIndex) => {
      const variantId = variants[tierIndex];
      if (!variantId) return;
      if (total >= amt) {
        addRewardToCart(root, variantId);
      } else {
        removeRewardFromCart(root, variantId);
      }
    });

    tagFreeGifts();
  }

  function scan() {
    document.querySelectorAll('[data-pdb]:not([data-pdb-done])').forEach((el) => {
      el.setAttribute('data-pdb-done', '');
      render(el);
    });
    tagFreeGifts();
  }

  // Eurus drawer ko section rendering se dobara likhta hai —
  // naya markup aate hi pakad lo
  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', scan);
  scan();
})();
